import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LocalizationContext } from '../App';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { BrowserView, MobileView, isDesktop, isMobile } from 'react-device-detect';
import Grid from '@mui/material/Grid';
import { alpha, styled } from '@mui/material/styles';
import env from "react-dotenv";
import { ThemeProvider, useTheme, createTheme } from '@mui/material/styles';
import { ReactSession } from 'react-client-session';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';

import { NameValueList, NameValuePair } from 'grommet';

const LoupeAppInformation = (props) => {

    ReactSession.setStoreType("localStorage");
    const userId = ReactSession.get("userid");
    

    return (
        
        <LocalizationContext.Consumer>

            { ({strings}) =>
            
                <Paper className="padding">                     
                    <div className="container padding">

                        <Typography gutterBottom component='div' className='mb-5' variant="h6">
                            {strings.getString("texts.titles.imprint")}
                        </Typography>

                        <Typography gutterBottom component='div' className='mb-5' variant="body">
                            {strings.getString("texts.responsibleParty")}
                        </Typography>

                        <Typography gutterBottom component='p' className='mb-6' variant="body2">
                            {process.env.REACT_APP_IMPRINT_NAME}, <br/>
                            {process.env.REACT_APP_IMPRINT_ADDRESS}. <br/>
                            {`E-mail: ${process.env.REACT_APP_IMPRINT_EMAIL}`}
                        </Typography>

                        <Divider className="mb-4" />

                        <Typography gutterBottom component="div" variant="caption">App-Version {process.env.REACT_APP_VERSION}</Typography>
                        <Typography gutterBottom component="div" className="mb-6" variant="caption">LOUPE, loupesight.city &copy; 2021&#8212;2022, Sebastian Scheuer, Daniel Wienhöfer, Jessica Jache.</Typography>

                    </div>
                </Paper>
            }
        </LocalizationContext.Consumer>
    );

}
export default LoupeAppInformation;